import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface ICountryRegistationPageDataResult {
  fetch: {
    Common: {
      Contact: {
        BackgroundColor: string | null;
        TitleColor: string | null;
      } | null;
    };
    Country: {
      RegistrationPage: {
        Title: string | null;
        ButtonLink: string | null;
        Content: string | null;
        ButtonText: string | null;
        ShowRegistrationPageButton: string | null;
      } | null;
    };
  };
}

interface IVariables {
  country: string;
}

interface IRequiredProps {
  country: string;
}

export interface IWithCountryRegistationPageQueryProps {
  contactQuery: QueryResult<ICountryRegistationPageDataResult>;
}

class CountryRegistationPageQuery extends Query<
  ICountryRegistationPageDataResult,
  IVariables
> {}

const withCountryRegistationPageQuery = <
  P extends IWithCountryRegistationPageQueryProps
>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, IWithCountryRegistationPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <CountryRegistationPageQuery
      query={queries.GET_REGISTRATION_PAGE_DATA}
      variables={{
        country
      }}
    >
      {providedProps => (
        <Component contactQuery={providedProps} {...props as any} />
      )}
    </CountryRegistationPageQuery>
  );
};

export default withCountryRegistationPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withCountryRegistrationPageQuery.tsx